/* -- Generated File: Do Not Edit ------------------------------------------ */
export const fontSizes = {
  fontSize0: '10px',
  fontSize1: '12px',
  fontSize2: '13px',
  fontSize3: '14px',
  fontSize4: '16px',
  fontSize5: '18px',
  fontSize6: '20px',
  fontSize7: '24px',
  fontSize8: '28px',
  fontSize9: '32px',
  fontSize10: '40px',
  fontSize11: '52px',
  fontSize12: '68px',
  fontSize13: '88px',
};

export default fontSizes;
/* -- Generated File: Do Not Edit ------------------------------------------ */
